// Generated by Melange

import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Curry from "melange.js/curry.js";
import * as React from "react";

function useClickOutside(dropdownRef, activatorRef, onClickOutside) {
  const handleMouseDown = function (ev) {
    const dropdown = dropdownRef.current;
    const activator = activatorRef.current;
    if (dropdown == null) {
      return;
    }
    if (activator == null) {
      return;
    }
    const target = ev.target;
    if (!dropdown.contains(target) && !activator.contains(target)) {
      return Curry._1(onClickOutside, ev);
    }
    
  };
  React.useEffect((function () {
    document.addEventListener("mousedown", handleMouseDown);
    return (function (param) {
      document.removeEventListener("mousedown", handleMouseDown);
    });
  }), []);
}

function scrollToBottom(param) {
  const body = document.body;
  const bodyHeight = (
    (body == null) ? undefined : Caml_option.some(body)
  ).scrollHeight;
  window.scrollTo(0, bodyHeight);
}

function scrollToFooter(deviceType) {
  const footerHeight = deviceType === "mobile" ? 1393 : 973;
  const body = document.body;
  const bodyHeight = (
    (body == null) ? undefined : Caml_option.some(body)
  ).scrollHeight;
  window.scrollTo(0, bodyHeight - footerHeight | 0);
}

function focusInput(input) {
  const __x = input.current;
  Belt__Belt_Option.map((__x == null) ? undefined : Caml_option.some(__x), (function (el) {
    return el.focus();
  }));
}

export {
  useClickOutside,
  scrollToBottom,
  scrollToFooter,
  focusInput,
}
/* react Not a pure module */
